function PageHeader({ children }) {
    return <h3 className="mb-3 font-heading text-[44px] lg:text-7xl">{children}</h3>;
}

export default PageHeader;
